<template>
<div id="footer">
	<div id="footer_top">
		<div id="page_top" v-on:click="goback">
			<img src="../assets/back.png">
		</div>

		<p><img src="../assets/foot_logo.png"></p>
		<div class="foot_cantact">
			<img src="../assets/foot_tel.png">
			<span>热线电话 : {{tel}}</span>
		</div>
	</div>
	<div class="banquan">
		<p><a href="https://beian.miit.gov.cn/" target="_blank">{{htbn}} 燕铺网 {{htkey}}</a></p>
		<p>源\力\滋\养&nbsp;&nbsp;&nbsp;好\孕\安\享</p>
	</div>
</div>
</template>
<script>
var localhref = window.location.host;
var localarr = localhref.split('.');

var ht={
            "com":"鲁ICP备2022014943号-2",
            "cn":"鲁ICP备2022014943号-3",
            "net":"鲁ICP备19029086号-2"
        }
//最新备案
var beian = {
  "cute666.cn":"鲁ICP备20032806号-1",
  "cute666.com":"鲁ICP备20032806号-4",
  "97qiyu.com":"鲁ICP备20032806号-3",
  "97qiyu.cn":"鲁ICP备20032806号-2",
  "iyanpu.com":"鲁ICP备2022014943号-2",
  "iyanpu.cn":"鲁ICP备2022014943号-3",
  "iyanpu.net":"鲁ICP备19029086号-2",
  "lc2021.cn": "鲁ICP备2021002979号-1",
  "gdt.ichuangmei.cn":"鲁ICP备17044811号"
}
var beianhao = beian['iyanpu.com'];
Object.keys(beian).forEach(function(key){
  if( localhref.indexOf( key ) != -1 ){
    beianhao = beian[key];
  }
})

export default {
  name: 'Footer',
  data:function(){
    return {
      tel:"400-852-7856",
      htbn:beianhao,
      htkey:localhref
    }
  },
  methods:{
      goback:function () {
           $('html').animate({
             scrollTop: '0'
         }, 1000);
      }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#footer {
    height:283px;
    width: 100%;
    max-width: 1920px;
    min-width: 1120px;
}

    #footer_top {
        width: 100%;
        height: 253px;
        background:url(../assets/foot_bj.png) no-repeat center center;
        background-size:cover;
        position: relative;
        padding-top: 5px;
    }
#footer_top p{ margin-top: 45px}
    #footer_top p img {
        display: block;
        margin: 0 auto;
    }


    .footer_bottom {
        width: 100%;
        text-align: center;
        margin-bottom: 20px;
    }

    .footer_bottom p {
        font-size: 14px;
        /*font-family: PingFangSC-Regular, sans-serif;*/
        letter-spacing: 2px;
        color: #1b1b1b;
    }

    .footer_bottom p:first-child {
        margin-top: 40px;
        margin-bottom: 10px;
    }

    .foot_cantact {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        width: 552px;
        margin: 0 auto;
        justify-content: center;
        font-size: 25px;
        color: #000000;
        align-items: center;
        height: 80px;
    }



    .foot_cantact img {
        width: 34px;
        height: 34px;
        margin-right: 21px;
    }
  #page_top {
        display: inline-block;
        position:absolute;
        right: 20%;
        top: -55px;
    }
.banquan{padding-bottom:50px; }
.banquan p{font-size: 25px; color: #000;letter-spacing:3px;}
.banquan p:first-child{ padding-top: 50px; padding-bottom: 30px;}

@media(max-width: 750px) {
    #footer{
        min-width: 750px;
         width: 750px;
    }
    #page_top{ display: none;}
}

</style>



// WEBPACK FOOTER //
// src/components/footer.vue